/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BombaFormComponent } from "./bomba-form/bomba-form.component";
import { editRoute, newRoute, detailRoute } from "../../shared/services/data.service";
import { BombaListComponent } from "./bomba-list/bomba-list.component";
import { bombasAuditoriaRoute } from "./shared/data.service";
import { BombaAuditoriaListComponent } from "./bomba-auditoria-list/bomba-auditoria-list.component";
import { BombaAuditoriaDetailComponent } from "./bomba-auditoria-detail/bomba-auditoria-detail.component";
import { BombaAuditoriaComponent } from "./bomba-auditoria/bomba-auditoria.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class BombasRoutingModule {}

export const bombasRoutes: any[] = [
    {
        path: '',
        component: BombaListComponent
    },{
        path: editRoute + '/:id',
        component: BombaFormComponent
    },{
        path: newRoute,
        component: BombaFormComponent
    }
];

export const auditoriaRoutes: any[] = [

            {
                path: '',
                component: BombaAuditoriaListComponent
            },{
                path: detailRoute + '/:id',
                component: BombaAuditoriaDetailComponent
            },{
                path: 'auditar/:id',
                component: BombaAuditoriaComponent
            }


];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bombas-routing.module.ts
 **/